import { voidFn } from '@simplisafe/ewok'
import * as O from 'fp-ts/lib/Option'
import { pipe } from 'fp-ts/lib/function'

import type { Trustpilot } from './trustPilot'

/**
 * Get TrustPilot and call a function using it.
 *
 * Handles checks for TrustPilot being undefined.
 */
export function getTrustPilot(fn: (t: Trustpilot) => void) {
  pipe(O.fromNullable(globalThis.window?.Trustpilot), O.fold(voidFn, fn))
}
